import { triggerOnContentLoaded, isContentLoaded } from 'bits/dom'

export default {
  data() {
    return {
      isDomLoaded: isContentLoaded(),
    }
  },
  beforeMount() {
    if (!this.isDomLoaded) {
      triggerOnContentLoaded(() => {
        this.isDomLoaded = true
      })
    }
  },
}
